import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SurveyDialogProvider } from "./context/SurveyDialogContext";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

import { useLocation } from "react-router-dom";

function RouteDebugger() {
  const loc = useLocation();
  console.log("ROUTE DEBUG:", loc.pathname, "window.location:", window.location.pathname);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-center font-body">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SurveyDialogProvider>
          <BrowserRouter>
            <RouteDebugger />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin/login/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/login/" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </SurveyDialogProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
